/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Switcher from 'shared/ui/components/Switcher.vue';
import BaseTextarea from 'shared/ui/components/form-components/BaseTextarea.vue';
import { PLATFORMS } from 'shared/libs/utils/constants';

const __vue_script__ = {
    name: 'LeadsAutomaticMappingPromptModal',

    components: { Switcher, BaseTextarea },

    props: {
        settings: {
            type: Object,
            required: true
        },
        defaultPrompts: {
            type: Object,
            required: true
        },
        save: {
            type: Function,
            required: true,
        },
    },

    data() {
        return {
            selectedPlatform: PLATFORMS.IOS,
            platforms: [
                { label: this.$t('leads.settings.prompt_modal.ios'), value: PLATFORMS.IOS },
                { label: this.$t('leads.settings.prompt_modal.android'), value: PLATFORMS.ANDROID }
            ],
            prompts: {
                [PLATFORMS.IOS]: this.settings.automatic_mapping_prompt_ios || this.defaultPrompts[PLATFORMS.IOS],
                [PLATFORMS.ANDROID]: this.settings.automatic_mapping_prompt_android || this.defaultPrompts[PLATFORMS.ANDROID],
            },
            isSaving: false,
        };
    },

    computed: {
        isSaveButtonDisabled() {
            return this.isSaving || !this.prompts[PLATFORMS.IOS] || !this.prompts[PLATFORMS.ANDROID];
        },
    },

    methods: {
        close() {
            this.$emit('close');
        },

        async submit() {
            this.isSaving = true;
            if (await this.save({
                automatic_mapping_prompt_ios: this.prompts[PLATFORMS.IOS],
                automatic_mapping_prompt_android: this.prompts[PLATFORMS.ANDROID],
            })) {
                this.close();
            }
            this.isSaving = false;
        },

        reset() {
            this.prompts[this.selectedPlatform] = this.defaultPrompts[this.selectedPlatform];
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-wrapper mapping-prompt-modal" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c(
        "a",
        {
          staticClass: "close",
          attrs: { "aria-label": _vm.$t("general.close") },
          on: { click: _vm.close },
        },
        [_vm._v("×")]
      ),
      _c("h3", [_vm._v(_vm._s(_vm.$t("leads.settings.prompt_modal.title")))]),
    ]),
    _c("div", { staticClass: "modal-body" }, [
      _c("p", [
        _vm._v(_vm._s(_vm.$t("leads.settings.prompt_modal.description"))),
      ]),
      _c("div", { staticClass: "alert info" }, [
        _vm._v(_vm._s(_vm.$t("leads.settings.prompt_modal.availability"))),
      ]),
      _c("div", { staticClass: "toolbar" }, [
        _c("p", [
          _vm._v(_vm._s(_vm.$t("leads.settings.prompt_modal.edit_prompt"))),
        ]),
        _c(
          "button",
          {
            staticClass: "btn",
            attrs: { type: "button", disabled: _vm.isSaving },
            on: { click: _vm.reset },
          },
          [
            _vm._v(
              _vm._s(
                _vm.$t("leads.settings.prompt_modal.reset_to_default_prompt")
              )
            ),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "editor" },
        [
          _c("base-textarea", {
            attrs: { name: "prompt", rows: 15, disabled: _vm.isSaving },
            model: {
              value: _vm.prompts[_vm.selectedPlatform],
              callback: function ($$v) {
                _vm.$set(_vm.prompts, _vm.selectedPlatform, $$v)
              },
              expression: "prompts[selectedPlatform]",
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn",
          attrs: { type: "button" },
          on: { click: _vm.close },
        },
        [_vm._v(_vm._s(_vm.$t("general.close")))]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button", disabled: _vm.isSaveButtonDisabled },
          on: { click: _vm.submit },
        },
        [_vm._v(_vm._s(_vm.$t("general.save")))]
      ),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/modals/LeadsAutomaticMappingPromptModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__